module.exports = __webpack_public_path__ + "static/media/brand-refresh-many.7559033f.svg";